// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"62b9fa70","460":"6e18cf62","483":"ec045e10","528":"8c7c55f7","545":"f4d3cf1b","579":"7425fd24","601":"6fc21edb","714":"da78d0e0","751":"ced24149","923":"ff77d585","927":"6998bbc0","933":"85f54344","988":"851b7e0d"}[chunkId] + ".chunk.js";
};